import { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import getImageUrl from "../utils/getImageUrl";

function PendingArticles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
const [selectedCategories, setSelectedCategories] = useState({});

  useEffect(() => {
    apiFetch("/articles/pending")
      .then(async res => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || "Failed to load pending articles");
        }
        return res.json();
      })
      .then(data => {
        setArticles(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
  apiFetch("/articles/categories")
    .then(res => res.json())
    .then(data => {
      console.log("Categories:", data);
      setCategories(Array.isArray(data) ? data : []);
    })
    .catch(err => {
      console.error("Failed to load categories", err);
      setCategories([]);
    });
}, []);

  const approve = async id => {
    const category = selectedCategories[id];

    if (!category) {
      alert("Please select or enter a category before approving.");
      return;
    }

    await apiFetch(`/articles/${id}/approve`, {
      method: "POST",
      body: JSON.stringify({ category })
    });

    setArticles(prev => prev.filter(a => a.id !== id));
  };

  const reject = async (id) => {
    await apiFetch(`/articles/${id}/reject`, {
      method: "POST",
      body: JSON.stringify({ reason: "Rejected by admin" })
    });

    setArticles(prev => prev.filter(a => a.id !== id));
  };

  return (
    <div>
      <h1>Pending Articles</h1>

      {articles.map(article => (
        <div key={article.id} className="pending-article">
          <img
            src={getImageUrl(article.image || "Placeholder.png")}
            alt={article.title}
            className="pending-article-image"
          />
          <h3>{article.title}</h3>
          <select
            value={selectedCategories[article.id] || ""}
            onChange={e =>
              setSelectedCategories(prev => ({
                ...prev,
                [article.id]: e.target.value
              }))
            }
          >
            <option value="">Select category</option>
            {categories.map(cat => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          <input
            type="text"
            placeholder="Or create new category"
            onChange={e =>
              setSelectedCategories(prev => ({
                ...prev,
                [article.id]: e.target.value
              }))
            }
          />
          <p>{article.description}</p>

          <div className="actions">
            <button onClick={() => approve(article.id)}>Approve</button>
            <button onClick={() => reject(article.id)}>Reject</button>
          </div>
          <hr className="hr-divider" />
        </div>
      ))}
    </div>
  );
}

export default PendingArticles;
